export const IMPORTED_PATIENT = 'imported_patient';
export const INTEGRATION = 'integration';

export const CONFIGURATION_TYPE_OPTS = [
  { label: 'File', value: IMPORTED_PATIENT },
  { label: 'Integration', value: INTEGRATION },
];

export const PLATFORM_OPTS = [
  { label: 'Epic', value: 'epic' },
  { label: 'MatrixCare', value: 'matrixcare' },
  { label: 'PCC', value: 'pcc' },
];

export const DELIMITER_OPTS = [
  { label: 'Comma Separated', value: ',' },
  { label: 'Pipe Separated', value: '|' },
  { label: 'Tab Separated', value: '\t' },
];

export type PatientMappingKey =
  | 'name'
  | 'externalId'
  | 'dateOfBirth'
  | 'sex'
  | 'hospitalAdmissionDate'
  | 'providerAdmissionDate'
  | 'address1'
  | 'address2'
  | 'city'
  | 'state'
  | 'zip'
  | 'phoneNumber';

export const PATIENT_MAPPINGS: { label: string; key: PatientMappingKey; optional?: boolean }[] = [
  { label: 'Patient Name', key: 'name' },
  { label: 'Patient ID', key: 'externalId' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Gender', key: 'sex' },
  { label: 'Hospital Admission Date', key: 'hospitalAdmissionDate', optional: true },
  { label: 'Network Provider Admission Date', key: 'providerAdmissionDate', optional: true },
  { label: 'Address 1', key: 'address1', optional: true },
  { label: 'Address 2', key: 'address2', optional: true },
  { label: 'City', key: 'city', optional: true },
  { label: 'State', key: 'state', optional: true },
  { label: 'Zip', key: 'zip', optional: true },
  { label: 'Phone Number', key: 'phoneNumber', optional: true },
];
